<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
      <div class="selections">
        <button-link
          type="success"
          to="/deposit_cards/create"
        >
          <slot>添加押金卡</slot>
        </button-link>
      </div>
    </div>

    <el-table
      :data="deposit_card"
      resource="deposit_cards"
    >
      <!--<el-table-column
        prop="id"
        label="ID"
        width="60"
        align="center"
      />-->
      <el-table-column
        prop="area_name"
        label="区域"
        align="center"
      />
      <el-table-column
        prop="name"
        label="名称"
        width="150"
        align="center"
      />

      <el-table-column
        prop="effective_days"
        label="有效天数"
        width="80"
        align="center"
      />

      <el-table-column
        prop="price"
        label="价格"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag>{{ scope.row.price }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="is_discount"
        label="是否折扣"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_discount"
            type="success"
          >有折扣</el-tag>
          <el-tag
            v-else
            type="danger"
          >无折扣</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="discount"
        label="折扣"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag>{{ scope.row.discount/10 }} 折</el-tag>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="area_name" label="区域">
        <template slot-scope="scope">
          <el-tag>{{ scope.area.name }} 折</el-tag>
        </template>
      </el-table-column> -->

      <el-table-column
        label="状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status"
            type="success"
          >启用</el-tag>
          <el-tag
            v-else
            type="danger"
          >禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="能否赠送"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_give"
            type="success"
          >是</el-tag>
          <el-tag
            v-else
            type="danger"
          >否</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="created_at"
        label="添加时间"
        width="160"
        align="center"
      />
      <el-table-column
        prop="updated_at"
        label="修改时间"
        width="160"
        align="center"
      />
      <el-table-column
        label="操作"
        width="250"
        align="center"
      >
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit />
            <row-destroy />
            <!-- <el-button type="success" @click="dialogVisibleClick(row)" size="small">送卡</el-button> -->
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="送卡"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <!-- <span>这是一段信息</span>
      -->

      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="骑行卡">
          <el-input
            disabled
            v-model="card_name"
          />
        </el-form-item>
        <el-form-item
          label="用户手机号"
          required
          prop="mobile"
        >
          <el-input v-model="form.mobile" />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="onSubmit"
        >确 定</el-button>
      </span>
    </el-dialog>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getRidingCard, giveCardToUser } from "@/api/card-riding";
import { getDepositCard } from "@/api/deposit-cards";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import ButtonLink from "@c/ButtonLink";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../../env";
export default {
  name: "Index",
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
    ButtonLink
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      dialogVisible: false,
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          field: "name",
          label: "名称"
        },
        {
          type: "el-select",
          field: "status",
          label: "是否禁用",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 1,
              name: "启用"
            },
            {
              id: 0,
              name: "禁用"
            }
          ]
        },
        {
          type: "el-select",
          field: "is_discount",
          label: "是否折扣",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 1,
              name: "有折扣"
            },
            {
              id: 0,
              name: "无折扣"
            }
          ]
        }
      ],
      deposit_card: [],
      page: null,
      first_blood: true,
      form: {
        mobile: "",
        card_id: ""
      },
      rules: {
        mobile: [{ validator: checkPhone, trigger: "blur" }]
      },
      card_name: "",
      areas: []
    };
  },
  async created() {
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);

    this.areas = areas;
    this.search[0].options.push.apply(this.search[0].options, areas);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[4].options.push.apply(
          this.search[4].options,
          merchant.data
        );
      }
    }
  },
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(48, newVal);
        const {
          data: { data, meta }
        } = await getDepositCard(newVal.query);
        this.deposit_card = data;
        console.log(this.deposit_card);
        this.page = meta;
      },
      immediate: true
    }
  },
  methods: {
    dialogVisibleClick(row) {
      this.form.card_id = row.id;
      this.dialogVisible = true;
      this.card_name = row.name;
      // console.log(this.card_name)
    },
    onSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          giveCardToUser(this.form).then(res => {
            res.then(data => {
              if (data) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
              }
            });
          });
          this.dialogVisible = false;
        } else {
          alert("请检查输入内容");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
